const SLIDES = [
  {
    src: '/assets/Vegetable%20Bag%20Clipart%20Image.jpeg',
    alt: 'Produits frais et courses',
  },
  {
    src: '/assets/Design%20sans%20titre%20(27).gif',
    alt: 'Animation produit Burok',
  },
  {
    src: '/assets/f57a264a71ffe86c2305a016b17878f7.jpg',
    alt: 'Univers shopping',
  },
  {
    src: '/assets/5668710df0e9b290b4345b7251b6e567.jpg',
    alt: 'Sélection produits',
  },
  {
    src: '/assets/001519871_101.avif',
    alt: 'Visuels catalogue',
  },
  {
    src: '/assets/91486f000ebe0add62f0544a1a2b9384.jpg',
    alt: 'Expérience boutique',
  },
] as const;

const shellClass =
  'group relative aspect-[5/4] w-64 shrink-0 overflow-hidden rounded-2xl border border-white/20 bg-white/[0.07] shadow-[0_16px_44px_-14px_rgba(0,0,0,0.38)] backdrop-blur-md sm:w-72 lg:w-80';

export function EcosystemRotatingCarouselFigure({ activeIndex }: { activeIndex: number }) {
  const safeIndex = ((activeIndex % SLIDES.length) + SLIDES.length) % SLIDES.length;

  return (
    <figure className={shellClass}>
      <div className="relative h-full w-full">
        {SLIDES.map((slide, i) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ease-in-out ${
              i === safeIndex ? 'z-[1] opacity-100' : 'z-0 opacity-0'
            }`}
            loading={i === 0 ? 'eager' : 'lazy'}
          />
        ))}
      </div>
      <div className="pointer-events-none absolute inset-0 z-[2] bg-gradient-to-t from-black/55 via-transparent to-transparent" />
      <figcaption className="absolute left-3 top-3 z-[3] rounded-full border border-white/25 bg-black/30 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white/95 backdrop-blur-sm sm:left-4 sm:top-4 sm:px-3 sm:py-1 sm:text-xs">
        Produits
      </figcaption>
    </figure>
  );
}

export const ECOSYSTEM_ROTATING_SLIDE_COUNT = SLIDES.length;
